import React, {useState, useEffect, useRef} from 'react'
import { generatePDF } from '../../Helpers/Utilities/generatePDF'
import { QRCodeSVG } from 'qrcode.react';
import userSilhouette from "../../../assets/user-silhouette.png";

export default function ProjectSingleCard({project, team, visibleFields, custom_field_values, project_avatar, public_card, logo}) {
  const [fieldValues, setFieldValues] = useState(custom_field_values)
  const [truncateId, setTruncateId] = useState(0)
  const [truncateUserId, setTrucateUserId] = useState(0)
  const [amount, setAmount] = useState(public_card.use_payments && public_card.donation_type == 'monthly' ? public_card.donation_amount : 50.00)

  const focusDivRef = useRef(null);

  useEffect(() => {
    if (focusDivRef.current) {
      focusDivRef.current.focus();
      focusDivRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, []);

  const printRef = useRef(null);
  
    const handleDownload = () => {
      generatePDF(printRef.current, public_card.title);
    };

  function canShowPublicField(customFields, field) {
    const foundField = customFields.find(
      (f) => f.system_key === field.toString()
    );
    return foundField && foundField.visible;
  }

  const canShowField = (field) => {
    const foundField = public_card.settings.fields.find((f) => f.id === field);
    if (foundField) {
        return true
    }

    return false
  }

  const getFieldValues = (project, field) => {
    if (field.system_key == 'bio') return project.bio
    const projectRecords = [];

    for (const innerArray of fieldValues) {
        const matchingRecords = innerArray.filter(value => value.record_id == project.id);
        projectRecords.push(...matchingRecords);
    }
    if (!projectRecords) return null

    let valueObject = projectRecords.find(record => record.team_custom_field_id == field.id)
    if (valueObject) return valueObject.value 
    return null
  }

  const truncateTest = (text, id, project_id) => {
    if (text.length > 200) {
        if (truncateId != id || truncateUserId != project_id) return text.substring(0, 200) + '...'
        if (truncateId == id && truncateUserId == project_id) return text
    } else {
        return text
    }
  }

  const visitSponsorPage = () => {
    let sponsorUrl = `/public/cards/sponsor/${project.id}/${public_card.unique_id}/new?type=signup`;
    if (public_card.use_payments) {
        sponsorUrl += `&amount=${amount}`;
    }

    if (public_card.use_payments && (!amount || amount < 1)) {
        Alert.show('notice', 'Donation amount must be more than $1')
        return
    }

    window.open(sponsorUrl, '_blank');
  }

    const getAmounts = (amount = null) => {
        const rawAmount = parseFloat(amount);
        if (!rawAmount || rawAmount <= 0) return '0.00';

        if (public_card.payment_method !== 'stripe') {
            return rawAmount.toFixed(2);
        }

        if (public_card.pass_processing_fee) {
            // Correct formula to ensure you net the original amount
            let raw_amount = rawAmount;
            let fee = (((raw_amount + 0.30) / (1 - 0.034)) - raw_amount).toFixed(2);
            let total = (parseFloat(raw_amount) + parseFloat(fee)).toFixed(2);
            return parseFloat(total).toFixed(2);
        }

        return rawAmount.toFixed(2);
    };

    const getProcessingFee = (amount = null) => {
        const rawAmount = parseFloat(amount);
        if (!rawAmount || rawAmount <= 0) return '0.00';
        
        // We calculate what the total would be, then subtract the original amount
        let total = (rawAmount + 0.30) / (1 - 0.034);
        let fee = total - rawAmount;
        
        return fee.toFixed(2);
    };

  return (
    <div>
        <button onClick={() => handleDownload()} className='btn btn-primary btn-sm' style={{cursor: 'pointer'}}>
            Download PDF
        </button>
        
    <div ref={printRef}>
        <div className='text-center' style={{margin: '0px'}}>
            {logo && (
                <div className="logo logo-sm" style={{maxWidth: 'unset !important'}}>
                    <img
                        src={logo} alt={team.name}
                        className='logo-for-public-card'
                        crossOrigin="anonymous"
                    />
                </div>
            )}
            {!logo &&
                <h1>{team.name}</h1>
            }
        </div>

        <div 
            style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }}
        >
                <div 
                    className='card'
                    style={{
                        width: '100%',
                        maxWidth: '400px',
                        minWidth: '300px',
                        height: 'fit-content',
                    }}
                >
                    <div className="p-2">
                        <img
                        src={project_avatar ? project_avatar : userSilhouette}
                        className="card-img-top rounded"
                        />
                    </div>

                        <div className='card-body pt-2'>
                            <div class="card-body pt-2">
                                <h4 className="mb-1 fw-bold">
                                    {canShowField("default-name") &&
                                    `${project.name} `}
                                </h4>

                                {canShowField('default-project manager') && project.manager &&
                                    <>
                                        <p className="text-bold small mb-2">
                                            {team.project_title} Manager
                                        </p>
                                        <p className="text-muted small"> {project.manager.first_name} {project.manager.last_name}</p>
                                    </>
                                }

                                {canShowField('default-project coordinator') && project.coordinator &&
                                    <>
                                        <p className="text-bold small mb-2">
                                            {team.project_title} Coordinator
                                        </p>
                                        <p className="text-muted small"> {project.coordinator.first_name} {project.coordinator.last_name}</p>
                                    </>
                                }

                                {canShowField('default-project information') &&
                                    <>
                                        <p className="text-bold small mb-2">
                                            {team.project_title} Information
                                        </p>
                                        {project.bio && project.bio.length > 0 ?
                                            <p className="text-muted small">
                                                {truncateTest(project.bio, "default-project information", project.id)}
                                                {truncateTest(project.bio, "default-project information", project.id).length <= 203 && 
                                                    project.bio.length > 200 &&
                                                    <span 
                                                        className='text-blue' 
                                                        onClick={() => { setTruncateId("default-project information"); setTrucateUserId(project.id)} }
                                                        style={{cursor: 'pointer', color: 'blue'}}
                                                    > 
                                                        {' show more' }
                                                    </span>
                                                }
                                                {truncateTest(project.bio, "default-project information", project.id).length > 203 &&
                                                    <span 
                                                        className='text-blue' 
                                                        onClick={() => {setTruncateId(0); setTrucateUserId(0)}} 
                                                        style={{cursor: 'pointer', color: 'blue'}}
                                                    > 
                                                        {' show less'}
                                                    </span>
                                                }
                                            </p>
                                             :
                                            <p className="text-muted small">
                                                No data available.
                                            </p>
                                        }
                                    </>
                                }

                                {visibleFields.map((field) => {
                                    const value = getFieldValues(project, field);
                                    return (
                                        <div>
                                        {value && value != "" && (
                                            <div key={field.id}
                                            className="mb-2 sponsorship-template-fields"
                                            >
                                                <p className="text-bold small mb-2">
                                                {field.name}
                                                </p>
                                                {value && field.value_type == 'link' &&
                                                    <a href={value} target='_blank'>{ field.anchor_text ? field.anchor_text : field.name }</a>
                                                }
                                                {value && field.value_type !== 'link' &&
                                                    <p className="text-muted small">
                                                        {truncateTest(value, field.id, project.id)}
                                                        {truncateTest(value, field.id, project.id).length <= 203 && 
                                                            value.length > 200 &&
                                                            <span 
                                                                className='text-blue' 
                                                                onClick={() => { setTruncateId(field.id); setTrucateUserId(project.id)} }
                                                                style={{cursor: 'pointer', color: 'blue'}}
                                                            > 
                                                                {' show more' }
                                                            </span>
                                                        }
                                                        {truncateTest(value, field.id, project.id).length > 203 &&
                                                            <span 
                                                                className='text-blue' 
                                                                onClick={() => {setTruncateId(0); setTrucateUserId(0)}} 
                                                                style={{cursor: 'pointer', color: 'blue'}}
                                                            > 
                                                                {' show less'}
                                                            </span>
                                                        }
                                                    </p>
                                                } 
                                            
                                            </div>
                                        )}
                                        </div>
                                    )
                                })}

                                {public_card.generate_qr_code &&
                                    <div className="qr-container">
                                        <p className="text-bold small mb-2">
                                            Confirmation QR Code
                                        </p>
                                        <QRCodeSVG 
                                            value={`${window.location.origin}/public/cards/sponsor/show/confirmation/${public_card.unique_id}/${project.id}`} 
                                            size={128}
                                            level={"H"} // High error correction
                                        />
                                    </div>
                                }

                                {!public_card.view_only && 
                                    <>

                                        {public_card.use_payments && public_card.donation_type == 'monthly' &&
                                            <div className='mt-3'>
                                                <h5><b>Total</b>: {`$${getAmounts(public_card.donation_amount)} / Month`}</h5>
                                            </div>
                                        }
                                        
                                        {public_card.use_payments && public_card.donation_type == 'one_time' &&
                                            <div className='mt-3'>
                                                <div>
                                                    <div className="form-group" style={{padding: '0px'}}>
                                                        <label htmlFor="donation_amount">Amount (USD)</label>
                                                        <input
                                                            className="form-control"
                                                            placeholder="100.00"
                                                            type="number"
                                                            name="donation_amount"
                                                            id="donation_amount"
                                                            value={amount}
                                                            step={10}
                                                            min={2.00}
                                                            onChange={(e) => {
                                                                setAmount(e.target.value)
                                                            }}
                                                        />
                                                    </div>
                                                </div>

                                                {public_card.use_payments && public_card.pass_processing_fee && public_card.payment_method == 'stripe' &&
                                                    <div className='mt-3'>
                                                        <h5><b>Processing Fee</b>: {`$${getProcessingFee(amount)}`}</h5>
                                                    </div>
                                                }
                                                

                                                {public_card.use_payments &&
                                                    <div className='mt-3'>
                                                        <h5><b>Total</b>: {`$${getAmounts(amount)}`}</h5>
                                                    </div>
                                                }
                                            </div>
                                        }

                                        <a className="btn btn-primary mt-3 text-center"
                                            href='#'
                                            onClick={visitSponsorPage}
                                            style={{margin: 'auto', display: 'block'}}
                                            ref={focusDivRef}
                                            tabIndex={-1}
                                        >
                                            Sponsor
                                        </a>
                                    </>
                                }   
                            </div>
                        </div>
                    </div>
        </div>
    </div>
    </div>
  )
}